import { Component, HostListener, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DialogService } from '../../services/dialog.service';
import {
  PullToRefreshState,
  createPullToRefreshState,
  getPullProgressBucket,
  handlePullToRefreshTouchEnd,
  handlePullToRefreshTouchMove,
  handlePullToRefreshTouchStart,
} from '../../utils/pull-to-refresh.util';

@Component({
  selector: 'app-pull-to-refresh',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './pull-to-refresh.component.html',
  styleUrl: './pull-to-refresh.component.sass',
})
export class PullToRefreshComponent {
  private dialogService = inject(DialogService);

  // Local pull-to-refresh state for this component
  state: PullToRefreshState = createPullToRefreshState(200);
  private refreshDialogOpen = false;

  get pullProgressBucket(): number {
    return getPullProgressBucket(this.state);
  }

  @HostListener('window:touchstart', ['$event'])
  onWindowTouchStart(event: TouchEvent): void {
    handlePullToRefreshTouchStart(this.state, event);
  }

  @HostListener('window:touchmove', ['$event'])
  onWindowTouchMove(event: TouchEvent): void {
    handlePullToRefreshTouchMove(this.state, event);
  }

  @HostListener('window:touchend', ['$event'])
  onWindowTouchEnd(_event: TouchEvent): void {
    const shouldOpenDialog = this.state.pullToRefreshTriggered && !this.refreshDialogOpen;

    handlePullToRefreshTouchEnd(this.state);

    if (shouldOpenDialog) {
      void this.openConfirmDialog();
    }
  }

  private async openConfirmDialog(): Promise<void> {
    if (this.refreshDialogOpen) {
      return;
    }

    this.refreshDialogOpen = true;
    try {
      const confirmed = await this.dialogService.confirm({
        i18nPrefix: 'shared.confirm.pullToRefresh',
        tone: 'info',
      });
      if (confirmed) {
        window.location.reload();
      }
    } finally {
      this.refreshDialogOpen = false;
    }
  }
}
